<script setup>
import RealEstateBrokerDesktopNavigationSubmenu from './RealEstateBrokerDesktopNavigationSubmenu.vue';

defineProps({
  active: { type: Boolean, default: false },
  collapsed: { type: Boolean, default: false },
  commissionItems: { type: Array, default: () => [] },
  commissionsOpen: { type: Boolean, default: false },
  investmentItems: { type: Array, default: () => [] },
  investmentsOpen: { type: Boolean, default: false },
  item: { type: Object, required: true },
  selectedCommission: { type: String, default: '' },
  selectedInvestment: { type: String, default: '' },
});

const emit = defineEmits(['select', 'selectCommission', 'selectInvestment']);
</script>

<template>
  <button
    :data-testid="`broker-desktop-nav-${item.id}`"
    class="flex h-14 w-full items-center gap-4 rounded-[10px] py-1 text-left text-base font-bold transition hover:bg-lais-bg-soft"
    :class="[
      active ? 'bg-[#EDF8F7] text-[#01988C]' : 'text-lais-text',
      collapsed ? 'justify-center px-0' : 'justify-between px-[22px]',
    ]"
    type="button"
    :aria-label="item.label"
    :aria-current="active ? 'page' : undefined"
    @click="emit('select', item.id)"
  >
    <span class="flex items-center gap-4">
      <span
        class="size-5 text-[#01988C]"
        :class="item.icon"
        aria-hidden="true"
      />
      <span v-if="!collapsed">{{ item.label }}</span>
    </span>
    <span
      v-if="!collapsed && ['commission', 'investment'].includes(item.id)"
      class="size-[22px] text-[#01988C]"
      :class="
        (item.id === 'commission' && commissionsOpen) ||
        (item.id === 'investment' && investmentsOpen)
          ? 'i-lucide-chevron-down'
          : 'i-lucide-chevron-up'
      "
      aria-hidden="true"
    />
  </button>
  <RealEstateBrokerDesktopNavigationSubmenu
    v-if="!collapsed && item.id === 'commission' && commissionsOpen"
    menu-id="commission"
    :items="commissionItems"
    :selected="selectedCommission"
    @select="emit('selectCommission', $event)"
  />
  <RealEstateBrokerDesktopNavigationSubmenu
    v-if="!collapsed && item.id === 'investment' && investmentsOpen"
    menu-id="investment"
    :items="investmentItems"
    :selected="selectedInvestment"
    @select="emit('selectInvestment', $event)"
  />
</template>
